import React from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import TextBox from "../../common/TextBox";
import ComboBox from "../../common/ComboBox";
import { provinces } from "../../../helpers/common.helper";
import Button from "../../common/Button";
import { ReactComponent as SearchSvg } from "../../../assets/tendering/magnifying-glass.svg";
import { ReactComponent as CloseSvg } from "../../../assets/icons/close-primary.svg";
import OutsideClickHandler from "react-outside-click-handler";

const AdvancedFilter = ({ defaultValue, onChange, onClose }) => {
  const handleFilterSubmit = (values) => {
    onChange(values);
  };

  return (
    <div className="advanced-filter">
      <Formik
        initialValues={
          defaultValue ?? {
            name: undefined,
            location: [],
            status: [],
          }
        }
        onSubmit={handleFilterSubmit}
      >
        <OutsideClickHandler onOutsideClick={onClose}>
          <Form className="advanced-filter-content">
            <div className="advanced-filter-header">
              <span className="advanced-filter-header__title">Filters</span>
              <CloseSvg width="24" onClick={onClose} />
            </div>
            <TextBox name="name" label="Project name" />
            <ComboBox
              name="location"
              label="Location"
              multi={true}
              options={provinces}
            />
            <ComboBox
              name="status"
              label="Status"
              multi={true}
              options={[{ name: "Announcement", value: 1 }]}
            />
            <div style={{ flexGrow: 1 }} />
            <Button label="Search" leadingIcon={<SearchSvg />} type="submit" />
          </Form>
        </OutsideClickHandler>
      </Formik>
    </div>
  );
};

AdvancedFilter.propTypes = {};

export default AdvancedFilter;
